import { fromJS } from 'immutable'

import {
  USERNAME_RECOVERY_POST,
  USERNAME_RECOVERY_UPDATE,
  USERNAME_ERROR,
} from 'actions/username'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  success: null,
})

export default function createUsernameReducer(state = initialState, action) {
  switch (action.type) {
    case USERNAME_RECOVERY_POST:
      return _postUsernameRecovery(state)
    case USERNAME_RECOVERY_UPDATE:
      return _updateUsernameRecovery(state, action.payload)
    case USERNAME_ERROR:
      return _errorUsername(state, action.payload)
    default:
      return state
  }
}

const _postUsernameRecovery = state => {
  return state.update('loading', () => true).update('success', () => null)
}

const _updateUsernameRecovery = (state, payload) => {
  return state
    .update('success', () => true)
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
}

const _errorUsername = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}
